'use client'

import { getBlockComponent } from '@/lib/notebook/registry/block-components'
import { blockRegistryEntry, resolveBlockType } from '@/lib/notebook/registry/blocks-registry-resolve'
import { getBlockDefaultData } from '@/lib/notebook/registry/blocks-registry-defaults'
import { LazyBlockSurface } from '@/lib/notebook/Blocks/shared/LazyBlockSurface'
import { BlockPresentationProvider } from './BlockModeContext'
import { BLOCK_PRESENTATION } from './constants'

/**
 * Renders any registry block inside Rich Text / tabs in embedded presentation.
 */
export function EmbeddedBlockHost({
  blockType,
  data,
  onChange,
  locked = false,
  sectionId,
}) {
  const resolved = resolveBlockType(blockType)
  const entry = blockRegistryEntry(resolved)
  const Comp = getBlockComponent(resolved)

  if (!entry || !Comp) {
    return (
      <div className="nb-embedded-block nb-embedded-block--missing" role="alert">
        Unknown embed: {String(blockType)}
      </div>
    )
  }

  const payload =
    data && typeof data === 'object' && Object.keys(data).length > 0
      ? data
      : getBlockDefaultData(resolved)

  const mode = BLOCK_PRESENTATION.EMBEDDED

  return (
    <div
      className="nb-embedded-block"
      data-embed-type={resolved}
      data-section-id={sectionId}
    >
      <BlockPresentationProvider mode={mode}>
        <LazyBlockSurface hostClassName="nb-embedded-block">
          <Comp
            data={payload}
            onChange={onChange}
            locked={locked}
            sectionId={sectionId}
          />
        </LazyBlockSurface>
      </BlockPresentationProvider>
    </div>
  )
}
